<template>
	<div>
		<header-page :title="`${$route.query.name} / ${$route.meta.title}`" />
		<accounting-parametrization-tab
			:disabled="loading"
			:rows="table.rows"
			:tabs="tabs"
			:step="step"
			@on-active-change="onActiveChange"
			@save-general-data="onSaveGeneralData"
			@save-seats="saveSeats"
			@save-misc-one="onSaveMiscOne"
			@reload-misc="reloadMisc"
			@set-Data="setData"
			@changeStep="changeStep"
			@chage-ste="changeSte"
			@edit-Data="editDataSetting"
			@save-Data="saveDataSetting"
		></accounting-parametrization-tab>
	</div>
</template>

<script>
	import accountingParametrizationTab from '@/components/accounting-parametrizations/accounting-parametrization-tab';
	import { mapGetters } from 'vuex';

	function created() {
		this.loadSettings();
	}
	function mounted() {
		this.params.subsidiaryId = this.subsidiaryId;
		this.loadData('type-register');
	}
	function setData(b) {
		this.dataSelectedAditionalInfo = b;
	}
	function onActiveChange(val) {
		if (Number(val) === 0) {
			this.params.subsidiaryId = this.subsidiaryId;
			this.loadData('type-register');
		} else if (Number(val) === 1) {
			this.params.subsidiaryId = null;
			/* this.loadData(`automatic-configuration/${this.subsidiaryId}/accounting`); */
		}
	}
	async function saveSeats() {
		this.step = 3;
	}

	async function onSaveGeneralData(rows) {
		this.loading = true;
		const { customerId, subsidiaryId } = this.$route.query;
		const body = rows.map((row) => {
			const newRow = {
				accountingDefinitionId: row.accountingDefinitionId,
				allowVisualize: !!row.allowVisualize,
				automaticAccounting: !!row.automaticAccounting,
				id: row.id,
			};
			return newRow;
		});
		try {
			await this.$http.patch(`type-register/${customerId}/${subsidiaryId}/multiple`, body);
			this.showNotification('La parametrización se realizó correctamente.');
			this.params.subsidiaryId = this.subsidiaryId;
			this.loadData('type-register');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
			this.step = 2;
		}
	}

	async function onSaveMiscOne(rows) {
		console.log('rows::: ', rows);
		this.loading = true;
		const companyId = this.currentSubsidiary.id;
		const { customerId, subsidiaryId } = this.$route.query;
		const settings = rows.map((row) => {
			const newRow = {
				account: row.account.replace(/\./g, ''),
				/* accountAlternate: row.accountAlternate.replace(/\./g, '') || '', */
				id: row.id,
			};
			return newRow;
		});
		const newData = {
			subsidiaryId,
			customerId,
			settings,
			companyId,
		};
		this.newDataSelected = newData;
		try {
			await this.$http.post('settings', newData);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.params.subsidiaryId = null;
			this.loadData(`automatic-configuration/${this.subsidiaryId}/accounting`);
			this.loadData('type-register');
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
			this.step = 3;
		}
	}
	async function loadSettings() {
		const { customerId, subsidiaryId } = this.$route.query;
		try {
			const { data: response } = await this.$http.get(`settings/${customerId}/${subsidiaryId}`);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables cargada.');
			this.params.subsidiaryId = null;
			this.dataSetting = response.settings;
			this.idEditSetting = response.id;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}
	async function changeStep() {
		this.step = 4;
	}

	function changeSte(value) {
		this.step = Number(value);
	}

	async function editDataSetting() {
		const { customerId, subsidiaryId } = this.$route.query;
		const additionalSettings = this.dataSelectedAditionalInfo;
		const settings = this.dataSetting;
		const companyId = this.currentSubsidiary.id;
		const newDataEdit = {
			additionalSettings,
			settings,
			customerId,
			subsidiaryId,
			companyId,
		};
		try {
			await this.$http.patch(`settings/${customerId}/${subsidiaryId}`, newDataEdit);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.params.subsidiaryId = null;
			this.loadData(`automatic-configuration/${this.subsidiaryId}/accounting`);
			this.params.subsidiaryId = this.subsidiaryId;
			this.loadData('type-register');
			this.step = 1;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	async function saveDataSetting() {
		const { customerId, subsidiaryId } = this.$route.query;
		const additionalSettings = this.dataSelectedAditionalInfo;
		const settings = this.dataSetting;
		const companyId = this.currentSubsidiary.id;
		const newDataEdit = {
			additionalSettings,
			settings,
			customerId,
			subsidiaryId,
			companyId,
		};
		try {
			await this.$http.post('settings', newDataEdit);
			/* await this.$http.patch(`automatic-configuration-multiple/${subsidiaryId}`, body); */
			this.showNotification('La configuración de cuentas contables ha sido guardada correctamente.');
			this.params.subsidiaryId = null;
			this.loadData(`automatic-configuration/${this.subsidiaryId}/accounting`);
			this.params.subsidiaryId = this.subsidiaryId;
			this.loadData('type-register');
			this.step = 1;
		} catch (err) {
			if (err.status === 500) {
				this.showGenericError();
			}
		} finally {
			this.loading = false;
		}
	}

	function currentSubsidiary(newSub) {
		const { id, name, customerId } = newSub;
		this.goTo(
			'accounting-parametrization',
			{
				params: { customerId, subsidiaryId: id },
				query: { subsidiaryId: id, customerId, name },
			},
		);
	}

	function routeHandler() {
		this.params.subsidiaryId = this.subsidiaryId;
		this.loadData('type-register');
	}

	function reloadMisc() {
		const { subsidiaryId } = this.$route.query;
		this.loadData(`automatic-configuration/${subsidiaryId}/accounting`);
	}

	function data() {
		return {
			loading: false,
			tabs: [
				{ id: 1, name: 'General', disabled: false },
				{ id: 2, name: 'Definición de Asientos', disabled: false },
				{ id: 3, name: 'Misceláneos 1', disabled: false },
				{ id: 4, name: 'Misceláneos 2', disabled: false },
			],
			newDataSelected: {},
			dataSelectedAditionalInfo: {},
			dataSetting: {},
			idEditSetting: 0,
			step: 1,
		};
	}

	export default {
		name: 'accounting-parametrization',
		components: {
			accountingParametrizationTab,
		},
		created,
		computed: {
			...mapGetters('subsidiary', [
				'currentSubsidiary',
			]),
		},
		data,
		methods: {
			onActiveChange,
			onSaveGeneralData,
			onSaveMiscOne,
			reloadMisc,
			routeHandler,
			setData,
			editDataSetting,
			saveDataSetting,
			loadSettings,
			saveSeats,
			changeStep,
			changeSte,
		},
		mounted,
		props: {
			subsidiaryId: [Number, String],
		},
		watch: {
			currentSubsidiary,
			'$route.params': routeHandler,
		},
	};
</script>



// WEBPACK FOOTER //
// src/pages/accounting-parametrizations/page-accounting-parametrization.vue